
import HeroSection from './components/HeroSection';
import FeaturesSection from './components/FeaturesSection';
import TradingToolsSection from './components/TradingToolsSection';
import DownloadSection from './components/DownloadSection';
import AdvantagesSection from './components/AdvantagesSection';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';

export default function PlatformPage() {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      <HeroSection />
      <FeaturesSection />
      <TradingToolsSection />
      <AdvantagesSection />
      <DownloadSection />
      <Footer />
    </div>
  );
}
